import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { MobileTopBar } from './MobileTopBar';
import { SidePanelProvider } from '@/components/sidepanel/SidePanelContext';
import { SidePanel } from '@/components/sidepanel/SidePanel';

/**
 * App-Shell des Spalten-Layouts: linke Menüleiste (Desktop) bzw. Top-Bar +
 * Drawer (mobil), danach der Spalten-Fluss (Liste | Detail | Vollbreite
 * Seite) aus der Route-Tabelle, ganz rechts die Split-View-Seitenleiste.
 * Der Shell-Root ist der Höhenanker (h-screen/100dvh, overflow-hidden) —
 * jede Spalte scrollt in sich (overflow-y-auto), nie das Dokument.
 */
export function AppShell() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <SidePanelProvider>
      <div className="flex h-screen supports-[height:100dvh]:h-[100dvh] flex-col overflow-hidden bg-gray-50 md:flex-row">
        {/* Mobil: schmale Top-Bar mit Hamburger */}
        <MobileTopBar onMenu={() => setIsMobileMenuOpen(true)} />

        <div className="flex min-h-0 min-w-0 flex-1">
          {/* Desktop: linke Menüleiste (aus dem Fluss, schiebt Inhalt nach rechts) */}
          <Sidebar variant="rail" />

          <Outlet />

          {/* Split-View-Seitenleiste — letztes Flex-Item, rechts (mobil Overlay) */}
          <SidePanel />
        </div>

        {/* Mobil: Drawer + Backdrop */}
        {isMobileMenuOpen && (
          <>
            <div
              className="fixed inset-0 z-40 bg-gray-900/40 md:hidden"
              onClick={() => setIsMobileMenuOpen(false)}
            />
            <Sidebar variant="drawer" onNavigate={() => setIsMobileMenuOpen(false)} />
          </>
        )}
      </div>
    </SidePanelProvider>
  );
}